import React, { CSSProperties } from "react";

export default function IconPerson(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M12 12q-1.6 0-2.8-1.2A4 4 0 0 1 8 8q0-1.6 1.2-2.8T12 4t2.8 1.2T16 8q0 1.6-1.2 2.8T12 12m-8 6v-.8q0-.8.4-1.6a3 3 0 0 1 1.2-1A15 15 0 0 1 12 13a14 14 0 0 1 6.4 1.6q.8.3 1.2 1t.4 1.6v.8q0 .9-.6 1.4a2 2 0 0 1-1.4.6H6a2 2 0 0 1-1.4-.6A2 2 0 0 1 4 18"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
